module.exports = __webpack_public_path__ + "media/img/vca/prizes/anjalichocolat-3b2689274989cd22a200b92ea0d996dc.png";